import React from 'react';
import './index.scss';
import {
    NavigationBar,
    IconChevronLeftRegular,
    skinVars,
    Text2,
    Divider,
    BoxedRow,
    IconMultisimRegular,
    Tag,
    ButtonLink,
    IconAddMoreRegular,
    IconInformationUserRegular,
    Callout,
    useWindowSize,
    useDialog,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { getRoleLine } from '../../../utils/dataTransformation/productConsumption';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import { useNavigate } from 'react-router-dom';
import { formatMobileNumber } from '../../../utils/dataTransformation/unitsConversion';
import { useConfigureLineContext } from '../../../utils/store/context/configure-line-context/ConfigureLineContext';
import { useQuery } from '@tanstack/react-query';
import { getSIMSInfo } from '../../../services/ConfigureLineService';
import BreadCrumbsWrapper from '../../../components/BreadcrumbsWrapper';

export const MultiSims: React.FC = () => {
    const navigate = useNavigate();
    const size = useWindowSize();
    const { lineActive, isConvergent } = useConfigureLineContext();
    const { dialog } = useDialog();
    const { data: simInfo } = useQuery(['sims-info'], () => (lineActive ? getSIMSInfo(lineActive) : null), {
        enabled: !!lineActive,
    });
    const consumptions = JSON.stringify(window.localStorage.getItem('storages'));

    return (
        <div className='multiSims-page'>
            <div className='multiSims-page__header'>
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='multiSims-page__header-navigationBar'>
                            <NavigationBar
                                withBorder={false}
                                onBack={() => {
                                    navigate(`/configure-line`);
                                }}
                                title={t('multiSim')}
                            />
                        </div>
                        <div
                            className='multiSims-page__header-return'
                            onClick={() => {
                                navigate(`/configure-line`);
                            }}
                        >
                            <div className='multiSims-page__header-return-icon'>
                                <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                            </div>
                            <Text2 medium color={skinVars.colors.textPrimary}>
                                {t('returnResponsive')}
                            </Text2>
                        </div>
                    </>
                )}
                <div className='multiSims-page__header-breadcrumbs'>
                    <BreadCrumbsWrapper
                        title={t('MultiSim')}
                        breadcrumbs={
                            !isConvergent
                                ? [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                                : [
                                      { title: t('breadcrumbsHome'), url: '/home' },
                                      {
                                          title: getRoleLine(JSON.parse(consumptions), simInfo?.productPsId!),
                                          url: `/mobile?productPsId=${simInfo?.productPsId}`,
                                      },
                                      {
                                          title: t('lineManagement'),
                                          url: `/configure-line`,
                                      },
                                  ]
                        }
                    />
                </div>
            </div>
            <Divider />
            <div className='multiSims-page__body'>
                {simInfo?.multiSims?.map((item, index) => (
                    <div className='multiSims-page__body-cards' key={index}>
                        <BoxedRow
                            asset={<IconMultisimRegular color={skinVars.colors.brand} size={24} />}
                            headline={
                                <Tag type={item?.pending ? 'warning' : 'success'}>
                                    {item?.pending ? t('statusMultiSim') : t('statusTag')}
                                </Tag>
                            }
                            title={item?.type === 'E_SIM' ? 'Multi eSIM' : 'Multi SIM'}
                            description={formatMobileNumber(simInfo?.number)}
                        ></BoxedRow>
                    </div>
                ))}

                <div className='multiSims-page__body-buttonLink'>
                    <ButtonLink
                        StartIcon={IconAddMoreRegular}
                        disabled={simInfo?.multiSims.some((multiSim) => multiSim.pending)}
                        onPress={() => {
                            simInfo?.multiSims.length && simInfo?.multiSims.length > 1
                                ? dialog({
                                      icon: <IconInformationUserRegular size={40} color={skinVars.colors.brand} />,
                                      title: t('dialogtitleEsim'),
                                      message: t('multisimAddLimitAlert'),
                                      acceptText: t('buttonUnderstoodFeedback'),
                                      onAccept() {},
                                  })
                                : navigate('/configure-line/multiSim/duplicate');
                        }}
                    >
                        {t('buttonLinkAddMultisim')}
                    </ButtonLink>
                </div>
                <div className='multiSims-page__body-callout'>
                    <Callout
                        icon={<IconInformationUserRegular color={skinVars.colors.brand} size={24} />}
                        title={t('multisimCalloutTitle')}
                        description={t('multisimCalloutDescription')}
                        buttonLink={
                            size.width < 1024 ? (
                                <ButtonLink
                                    onPress={() => {
                                        navigate('tel://1551');
                                    }}
                                >
                                    {t('numberTlfBtn')}
                                </ButtonLink>
                            ) : (
                                <div></div>
                            )
                        }
                    ></Callout>
                </div>
            </div>
        </div>
    );
};

export default MultiSims;
